
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Slide } from '@hokify/hooper';
import SectionStyling from '~/mixins/SectionStyling';

@Component({
	name: 'StepByStepSection',
	components: {
		HokCarousel: () => import('@hokify/shared-components/lib/components/HokCarousel.vue'),
		Slide
	}
})
export default class StepByStepSection extends Mixins(SectionStyling) {
	@Prop({ type: Array, default: () => [] }) readonly steps!: {
		image: string;
		alt: string;
		text?: string;
		styledText?: string;
		inlineLink?: string;
	}[];

	@Prop({ type: String, default: '' }) readonly headline!: string;

	@Prop({ type: Boolean, default: false }) readonly centerHeadline!: boolean;

	@Prop({ type: Boolean, default: false }) readonly centerSteps!: boolean;

	@Prop({ type: Boolean, default: false }) readonly hideButton!: boolean;

	@Prop({ type: String, default: '' }) readonly customButtonText?: string;

	clickedCTA(emitOnly: boolean, inline?: boolean) {
		if (!emitOnly) {
			this.$trackWebsiteEvent('go_to_pricing_page', {
				pageElement: inline ? '3_step_description_inline' : '4_step_description'
			});
		}
		this.$emit('clicked-cta');
	}
}
